/* dg-buybox-summary.js
   Sous-total live de la buy box → alimente :
     - le sous-texte du bouton « Ajouter au panier » ([data-bb-atc-subtotal])
     - la barre collante mobile ([data-bb-sticky-total] / [data-bb-sticky-count])

   Total = prix variante courante × quantité + Σ(prix des add-ons "Souvent acheté
   ensemble" cochés). Recalcul sur : changement de quantité, de variante, de case/variante
   d'add-on, et à l'injection async du bundle (repli IA). Aucun stockage local.

   ⚠️ Le sélecteur de variante REMPLACE les zones [data-dynamic-variant-content]
   (input id + cta-row contenant le bouton, le qty et la sous-ligne). On re-requête
   donc les éléments à chaque refresh et on planifie via rAF (DOM stabilisé).
*/
(function () {
  function init(form) {
    if (form.dataset.bbSummaryReady) return;
    var cfgEl = form.querySelector('[data-bb-buybox-config]');
    if (!cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[dg-buybox-summary] config JSON invalide', e); return; }
    form.dataset.bbSummaryReady = '1';

    var prices = cfg.prices || {};
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: cfg.currency || 'EUR' });
    } catch (e) {
      fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } };
    }

    function mainPriceCents() {
      var idInput = form.querySelector('[name="id"]');
      var id = idInput && idInput.value;
      if (id != null && prices[id] != null) return prices[id];
      var keys = Object.keys(prices);
      return keys.length ? prices[keys[0]] : 0;
    }

    function qty() {
      var qtyInput = form.querySelector('[name="quantity"]');
      var q = parseInt(qtyInput && qtyInput.value, 10);
      return q > 0 ? q : 1;
    }

    function addons() {
      var sum = 0, n = 0;
      form.querySelectorAll('bb-bundle [data-bb-bundle-checkbox]').forEach(function (cb) {
        if (!cb.checked || cb.disabled) return;
        n++;
        var row = cb.closest('[data-bb-bundle-item]');
        var sel = row && row.querySelector('[data-bb-bundle-select]');
        var p = NaN;
        if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
          p = parseInt(sel.selectedOptions[0].dataset.price, 10);
        }
        if (isNaN(p)) p = parseInt(cb.dataset.price, 10);
        sum += isNaN(p) ? 0 : p;
      });
      return { sum: sum, n: n };
    }

    function articleLabel(count) {
      var label = count === 1 ? cfg.itemSingular : cfg.itemPlural;
      return count + ' ' + (label || (count === 1 ? 'item' : 'items'));
    }

    function refresh() {
      var q = qty();
      var a = addons();
      var totalCents = mainPriceCents() * q + a.sum;
      var count = q + a.n;
      var money = fmt.format(totalCents / 100);

      var subEl = form.querySelector('[data-bb-atc-subtotal]');
      if (subEl) {
        subEl.textContent = articleLabel(count) + ' · ' + money;
        subEl.hidden = false;
      }
      var stTotal = document.querySelector('[data-bb-sticky-total]');
      var stCount = document.querySelector('[data-bb-sticky-count]');
      if (stTotal) stTotal.textContent = money;
      if (stCount) stCount.textContent = articleLabel(count);
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        scheduled = false;
        refresh();
      }, 0);
    }

    // Délégation : quantité, variante (input id remplacé → 'change' bubble), add-ons.
    form.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('[name="quantity"]')) schedule();
    });
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[name="id"], [name="quantity"], [data-bb-bundle-checkbox], [data-bb-bundle-select]')) schedule();
    });
    document.addEventListener('on:variant:change', schedule);

    // Injection async du bundle (repli IA) : on n'observe QUE s'il y a un
    // placeholder <bb-bundle-async>, et on se déconnecte dès la boîte injectée.
    if (form.querySelector('bb-bundle-async')) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var nd = added[j];
            if (nd.nodeType === 1 && ((nd.matches && nd.matches('bb-bundle')) || (nd.querySelector && nd.querySelector('bb-bundle')))) {
              mo.disconnect();
              schedule();
              return;
            }
          }
        }
      });
      mo.observe(form, { childList: true, subtree: true });
    }

    refresh();
  }

  function boot() {
    // Robuste : on trouve le form via le bloc de config (peu importe la classe du form).
    var cfgs = document.querySelectorAll('[data-bb-buybox-config]');
    if (cfgs.length) {
      cfgs.forEach(function (cfgEl) {
        var form = cfgEl.closest('form');
        if (form) init(form);
      });
      return;
    }
    // Repli : par classe de formulaire.
    document.querySelectorAll('form.js-product-form-main').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
